//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import membersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import { setPluginIcon } from "@/assets/js/appFunc";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    components: {
        membersListInfo,
        AQCard,
        AQChip,
        AQBadge
    },
    props: {
        mode: {
            type: String,
            default: "api", // api - ApiTab, blc - BlockchainTab, msg - MessagesTab
            validator: v => ["api", "blc", "msg"].includes(v.toLowerCase())
        },
        blockchain: {
            type: Object,
            default: () => {}
        },
        api: {
            type: Object,
            default: () => {}
        },
        message: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        computedError() {
            let hasError = false;
            if (this.mode === "blc" && this.blockchain.error) {
                hasError = true;
            }
            if (this.mode === "api" && this.api.error) {
                hasError = true;
            }
            if (this.mode === "msg" && this.message.isFailed && !this.message.deleteEventList) {
                hasError = true;
            }
            return hasError;
        },
        computedName() {
            let name = "";
            switch (this.mode) {
                case "blc":
                    name = this.blockchain.smartContractName;
                    break;
                case "api":
                    name = `${this.api.apiGivenName} - ${this.api.apiId}`;
                    break;
                case "msg":
                    name = this.message.connectorName
                        ? this.message.connectorName
                        : this.message.activityName;
                    break;
                     // no default
            }
            return name;
        },
        computedDateFormat() {
            let myDate = "";
            switch (this.mode) {
                case "blc":
                    myDate = this.dateFormat(this.blockchain.execStartDate);
                    break;
                case "api":
                    myDate = this.dateFormat(this.api.execStartDate);
                    break;
                case "msg":
                    myDate = this.dateFormat(this.message.generated);
                    break;
                     // no default
            }
            return myDate;
        },
        computedMethodName() {
            let methodName = "";
            switch (this.mode) {
                case "blc":
                    methodName = this.blockchain.functionName;
                    break;
                case "api":
                    methodName = this.api.methodName;
                    break;
                case "msg":
                    methodName = "this.blockchain.smartContractName";
                    break;
                     // no default
            }
            return methodName;
        },
        computedActivityName() {
            let activityName = "";
            switch (this.mode) {
                case "blc":
                    activityName = this.blockchain.activityName;
                    break;
                case "api":
                    activityName = this.api.activityName;
                    break;
                case "msg":
                    activityName = "this.blockchain.smartContractName";
                    break;
                    // no default
            }
            return activityName;
        },
        computedUsername() {
            let userName = "";
            switch (this.mode) {
                case "blc":
                    userName = this.blockchain.username;
                    break;
                case "api":
                    userName = this.api.username;
                    break;
                case "msg":
                    userName = "this.blockchain.smartContractName";
                    break;
                 // no default
            }
            return userName;
        },
        checkStatus() {
            let showDeleted = false;
            if (this.mode === "msg" && this.message.deleteEventList) {
                showDeleted = true;
            }
            return showDeleted;
        },
        showChevron() {
            let chevron = true;
            if (this.mode === "msg" && this.message.deleteEventList) {
                chevron = false;
            }
            return chevron;
        }
    },
    methods: {
        setPluginIcon,
        getConcatList(users, plainText) {
            const formattedRecipientsArray = [];
            if (users && users.length) {
                for (let i = 0; i < users.length; i++) {
                    formattedRecipientsArray.push({
                        name: users[i].username,
                        status: users[i].userStatus,
                        type: "users"
                    });
                }
            }
            if (plainText && plainText.length) {
                for (let i = 0; i < plainText.length; i++) {
                    formattedRecipientsArray.push({
                        name: plainText[i],
                        type: "plainText"
                    });
                }
            }
            return formattedRecipientsArray;
        },
        stopPropagation(event) {
            event.stopPropagation();
        },
        addMsgBgColor(value) {
            return value === "SMS"
                ? "background-color: #00CC66"
                : "background-color: #4285F4";
        },
        dateFormat(data) {
            const newDate = new Date(data);
            let formattedDate = date.formatDate(newDate, APP_DATE_DOT_FORMAT);
            formattedDate = formattedDate.replace(/ /g, " at ");
            return formattedDate;
        },
        setPlugin() {
            let pluginColor = "";
            if (this.mode === "blc") {
                pluginColor = this.setPluginIcon(
                    this.blockchain.activityType
                );
            } else if (this.mode === "api") {
                pluginColor = this.setPluginIcon(this.api.activityType);
            } else if (this.mode === "msg") {
                pluginColor = this.setPluginIcon(
                    this.message.activityType
                );
            }
            return pluginColor;
        },
        getChipProps(details) {
            const { username, email, userStatus } = details;
            const typeToReturn = userStatus === "DISABLED" ? "disabledUser" : "user";
            return {
                type: typeToReturn,
                fromInnerMenu: true,
                content: username.trim() || email
            };
        }
    }
};
